export default {
  userManagement: {
    pageTitle: "Quản lý Người dùng",
    pageDescription: "",
    pageKeywords: "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",

    
  },
  creatorDashboard : {
    pageTitle: "Creator Dashboard",
    pageDescription: "Welcome back! Manage your works and track your performance.",
    pageKeywords: "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",
  }

};
